import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/core/service/auth.service';

@Injectable({ providedIn: 'root' })
export class ParametreGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.hasAccess('PARAMETRES')) return true;
    this.router.navigate(['/authentication/signin']);
    return false;
  }
}
